import { createAction, createReducer } from "@reduxjs/toolkit";

const ContractData = createAction("ContractData");

// reducers.js
const initialState = {
  contractdata: [],
};

export const contractFormReducer = createReducer(initialState, (builder) => {
  builder.addCase(ContractData, (state, action) => {
    state.contractdata = action.payload;
  });
});
